import moment from 'moment';
import _ from 'lodash';
import i18n from '@/i18n';

import store from '@/store';

export function resourceGetter(resourceName) {
  return function getter(resourceId) {
    if (!resourceId) return undefined;
    if (Array.isArray(resourceId)) return resourceId.map(getter).filter($ => !!$);
    const resource = store.getters[`${resourceName}ById`][resourceId];
    return resource;
  };
}

const resourceGetters = _.memoize(resourceGetter);

export function resourceFormatter(resourceName, formatter = $ => $) {
  const getter = resourceGetters(resourceName);

  return (value, format = formatter) => {
    if (!value) return null;
    const resource = getter(value);
    if (!resource) return undefined;
    const formatFn = _.isFunction(format) ? format : $ => $[format];

    if (Array.isArray(resource)) return resource.map(formatFn);
    return formatFn(resource);
  };
}

export function booleanFormatter(value, { trueLabel = 'Oui', falseLabel = 'Non' } = {}) {
  if (value === true) return trueLabel;
  if (value === false) return falseLabel;
  return null;
}

export function dateFormatter(value, { format = i18n.t('date.formats.default') } = {}) {
  if (!value) return null;
  return moment(value).format(format);
}

export function datetimeFormatter(value, { format = `${i18n.t('date.formats.default')} ${i18n.t('time.formats.short')}` } = {}) {
  if (!value) return null;
  return moment(value).format(format);
}

export default {
  dateFormatter,
  datetimeFormatter,
  resourceFormatter,
};
